import React from 'react'
import { Link } from 'react-router-dom';

import { sourceCodeList } from "../config/constant";
export default function Home() {
    const componentBlock = (element, index) => {
        return (
            <div key={index}>
                <div className="card text-center border-dark h-100">
                    <h5 className="card-header">{element.component_name}</h5>
                    <div className="card-body">
                        <p className="card-text">{element.description}</p>
                        <Link to={element.path} className="btn btn-primary">View Code</Link>
                    </div>
                </div>
            </div>
        )
    }
    return (
        <div className='container my-2'>
            <h2 className='text-center'>Component</h2>
            <div className="row-1">
                {sourceCodeList.map((elements, index) => {
                    return (
                        elements.type ? (
                            <>
                                <h2 className='mt-4'>{elements.typeName}:</h2>
                                <div className="row row-cols-1 row-cols-md-2 g-4">
                                    {elements.subs.map((element, indexs) =>
                                        componentBlock(element, indexs))
                                    }
                                </div>
                            </>
                        ) : (
                            <>
                                <h2 className='mt-3'>{elements.component_name}:</h2>
                                <div className="row row-cols-1 row-cols-md-2 g-4">

                                    {componentBlock(elements, index)
                                    }</div>
                            </>
                        )
                    )
                })}
            </div>
        </div>
    )
}

